import type { ComponentProps, FC } from 'react';
import { useCallback } from 'react';

import ModalBody from '@trend-dev/trendtech-ui/components/UI/Modal/ModalBody';
import ModalDialog from '@trend-dev/trendtech-ui/components/UI/Modal/ModalDialog';
import ModalHeader from '@trend-dev/trendtech-ui/components/UI/Modal/ModalHeader';

import Browsers from 'components/Pages/DevicePermissionDenied/Browsers';

import { useDeviceWidth } from 'hooks/useDeviceWidth';

import { useCameraContext } from '../CameraPermissionContext';
import styles from './styles.module.scss';

const paperProps: ComponentProps<typeof ModalDialog>['paperProps'] = {
    shellClassName: styles.shell,
};

const CameraTutorialModal: FC = () => {
    const { setTutorialState, tutorialState } = useCameraContext();
    const { isDesktop } = useDeviceWidth();

    const closeHandler = useCallback(() => {
        setTutorialState(false);
    }, []);

    if (!tutorialState) return null;

    return (
        <ModalDialog size='lg' borderRadius='xl' paperProps={paperProps} open={tutorialState} onClose={closeHandler}>
            <ModalHeader onClose={closeHandler} spaceY={isDesktop ? 3 : undefined} />
            <ModalBody scrollInside className={styles.modalBody}>
                <Browsers />
            </ModalBody>
        </ModalDialog>
    );
};

export default CameraTutorialModal;
